<template>
    <div @click="sort" :class="newClass">
        <span class="pointer">
            <span class="caret-wrapper">
                <i class="sort-caret ascending"></i>
                <i class="sort-caret descending"></i>
            </span>
            {{ title }}
        </span>
    </div>
</template>

<script>
  export default {
    props:{
      title: String,
      statusSort: Object,
      sortKey: String,
      classDislpay: ''
    },
    name: 'HeaderSortTitle',
    data () {
      return {}
    },
    computed:{
      newClass(){
        if (this.statusSort[this.sortKey] === 0) {
          return ''
        }
        else if (this.statusSort[this.sortKey] === 1) {
          return  'ascending'
        }
        else if (this.statusSort[this.sortKey] === -1) {
          return 'descending'
        }
      }
    },
    methods:{
      sort(){
        this.$emit('sort', this.sortKey)
      }
    }

  }
</script>

<style scoped lang="scss">
    th {
        .cell {
            .pointer {
                cursor: pointer;
            }
        }
    }
</style>
